module.exports = __webpack_public_path__ + "static/media/tone3_bad.6b1838b9.svg";